const willReset = new Set([
    "Mval96BecomesInvalid",
    "Mval96BecomesValid",
    "Mval96MustRecalculate",
]);
export const willResetMval96 = (input) => {
    if (!input)
        return false;
    const list = Array.isArray(input) ? input : [input];
    return list.some(item => willReset.has(item));
};
//# sourceMappingURL=mval96.js.map